import { ICellRendererParams } from "ag-grid-community";
import { FC, useState } from "react";
import { IconButton } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useAxios } from "myAxios";
import { EditOutlined } from "@mui/icons-material";
import Reason from "../NewEM/Reason";
import { toast } from "react-toastify";
import { classHOC } from "components/app/ClassWrapper";

const ReasonRenderer: FC<ICellRendererParams & { type: string }> = ({
  data,
  column,
  node,
  value,
  type = "account",
}) => {
  const [showForm, setShowForm] = useState(false);
  const [newVal, setNewVal] = useState(value);
  const { control } = useForm();
  const axios = useAxios();

  const val = newVal ? newVal : value;

  const handleChange = async (val: string) => {
    setNewVal(val?.trim());
    setShowForm(false);
    // call update AEM/WEM api
    if (data?.accountKey && val !== value) {
      try {
        await axios
          .patch(`/api/dataservice/v1/accounts/${type}-engagement-model`, {
            accountKeys: [data?.accountKey],
            reason: val,
          })
          .then((res) => {
            const result = res.data;
            // console.log(result);
            if (type === "account") {
              // AEM
              node.setDataValue("coverageStatus", result?.[data?.accountKey]);
            } else {
              // WEM
              const field = column.getColId().split("Exp")?.[0];
              node.setDataValue(field, result?.[data?.accountKey]);
            }
          })
          .catch((e) => {
            toast.error(e?.response?.data?.message || `Failed to update reason`, {
              position: "top-center",
              autoClose: 3000,
            });
          });
      } catch (e) {
        toast.error(e?.response?.data?.message || `Failed to update reason`, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    }
  };

  // const editable =
  //   ([ROLE.MANAGER_ROLE].includes(authDetail.role) &&
  //     authDetail.features.includes(FEATURE_KEY.UPDATE_ACCOUNT_COVERAGE)) ||
  //   (authDetail.role === ROLE.DEV_ROLE && handleEditReason());
  const editable = false;

  if (node.rowPinned) {
    return <></>;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
      }}
      className="hover-show-container"
    >
      {showForm ? (
        <div
          onKeyPress={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          onContextMenu={(e) => e.stopPropagation()}
        >
          <Controller
            control={control}
            render={(props) => (
              <Reason
                {...props}
                hideTitle={true}
                handleChange={handleChange}
              />
            )}
            name={"Reason"}
            defaultValue={newVal || ""}
            rules={{
              required: {
                message: "This field is required!",
                value: true,
              },
              maxLength: { value: 150, message: "Maximum 50 characters" },
            }}
          />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <span style={{ lineHeight: 1.3, marginTop: 12 }}>{val ? val : "N/A"}</span>
          </div>

          {editable && (
            <IconButton
              size="small"
              className={"hover-show"}
              onClick={() => {
                setShowForm(true);
              }}
              style={{
                marginLeft: 10,
                height: "fit-content",
                lineHeight: 1.3,
                marginTop: 10,
              }}
            >
              <EditOutlined style={{ color: "#00a0d1", fontSize: "1rem" }} />
            </IconButton>
          )}
        </div>
      )}
    </div>
  );
};

export default classHOC(ReasonRenderer);
